"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromoBlocksAlternative = void 0;
var PromoBlocks_1 = require("./PromoBlocks");
Object.defineProperty(exports, "PromoBlocksAlternative", { enumerable: true, get: function () { return __importDefault(PromoBlocks_1).default; } });
